import { SET_CONTACT_INFO } from '../actions/actionTypes';

const contactInfo = (state = null, action = {}) => {
    switch (action.type) {
        case SET_CONTACT_INFO:
            return action.value;
        default: return state;
    }
}

export default contactInfo;